var _defs, _path, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _rect2, _polygon30, _rect3, _polygon31, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _polygon32, _rect19, _path3, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path4, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _polygon33, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _polygon34, _polygon35, _polygon36, _rect52, _rect53, _rect54, _rect55, _rect56, _polygon37, _polygon38, _polygon39, _polygon40, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fed287;}.cls-3{fill:#d0635a;}.cls-4{fill:#f97b70;}.cls-5{fill:#eab568;}.cls-6{fill:#29414c;}.cls-7{fill:#556169;}.cls-8{fill:#90c1dd;}.cls-9{fill:#9b9b9b;}.cls-10{fill:#d3d3d3;}.cls-11{fill:#a0b1b5;}.cls-12{fill:#5bd8a9;}.cls-13{fill:#58bf95;}.cls-14{fill:#938580;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "casas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.11,188.51H4.89a.89.89,0,1,1,0-1.77H224.11a.89.89,0,1,1,0,1.77Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.59,
    y: 96.1,
    width: 67.01,
    height: 90.53
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.6 76.92 45.72 100 116.73 100 116.73 76.92 50.6 76.92"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "45.72 100 46.17 100 51.06 76.92 50.6 76.92 45.72 100"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "48.39 100 48.84 100 53.72 76.92 53.27 76.92 48.39 100"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.06 100 51.51 100 56.39 76.92 55.94 76.92 51.06 100"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.72 100 54.18 100 59.06 76.92 58.6 76.92 53.72 100"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.39 100 56.84 100 61.73 76.92 61.27 76.92 56.39 100"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "59.06 100 59.51 100 64.39 76.92 63.94 76.92 59.06 100"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.73 100 62.18 100 67.06 76.92 66.61 76.92 61.73 100"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.39 100 64.85 100 69.73 76.92 69.28 76.92 64.39 100"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "67.06 100 67.52 100 72.4 76.92 71.94 76.92 67.06 100"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "69.73 100 70.18 100 75.06 76.92 74.61 76.92 69.73 100"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "72.4 100 72.85 100 77.73 76.92 77.28 76.92 72.4 100"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.06 100 75.52 100 80.4 76.92 79.94 76.92 75.06 100"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "77.73 100 78.19 100 83.07 76.92 82.61 76.92 77.73 100"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.4 100 80.85 100 85.73 76.92 85.28 76.92 80.4 100"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "83.07 100 83.52 100 88.4 76.92 87.95 76.92 83.07 100"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.73 100 86.19 100 91.07 76.92 90.62 76.92 85.73 100"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "88.4 100 88.86 100 93.74 76.92 93.28 76.92 88.4 100"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "91.07 100 91.52 100 96.4 76.92 95.95 76.92 91.07 100"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "93.74 100 94.19 100 99.07 76.92 98.62 76.92 93.74 100"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "96.4 100 96.86 100 101.74 76.92 101.29 76.92 96.4 100"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "99.07 100 99.53 100 104.41 76.92 103.95 76.92 99.07 100"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "101.74 100 102.19 100 107.08 76.92 106.62 76.92 101.74 100"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "104.41 100 104.86 100 109.74 76.92 109.29 76.92 104.41 100"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.08 100 107.53 100 112.41 76.92 111.96 76.92 107.08 100"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "109.74 100 110.2 100 115.08 76.92 114.62 76.92 109.74 100"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "116.73 92.2 115.08 100 115.53 100 116.73 94.35 116.73 92.2"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "116.73 79.59 112.41 100 112.86 100 116.73 81.74 116.73 79.59"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.59 100 91.07 186.63 116.57 186.63 116.57 100 49.59 100"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 49.56,
    y: 173.21,
    width: 67.01,
    height: 13.42
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.15 135.87 49.15 136.61 49.15 138.28 56.02 138.28 56.02 136.61 59.32 136.61 59.32 138.28 66.19 138.28 66.19 136.61 69.48 136.61 69.48 138.28 76.36 138.28 76.36 136.61 79.66 136.61 79.66 138.28 86.53 138.28 86.53 136.61 89.83 136.61 89.83 138.28 96.7 138.28 96.7 136.61 100 136.61 100 138.28 106.87 138.28 106.87 136.61 110.17 136.61 110.17 138.28 117.04 138.28 117.04 136.61 117.04 135.87 49.15 135.87"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 56.82,
    y: 151.87,
    width: 14.73,
    height: 27.22
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.03 178.42 57.03 152.07 71.34 152.07 71.34 178.42 71.79 178.42 71.79 151.63 56.59 151.63 56.59 178.42 57.03 178.42"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 59.52,
    y: 154.49,
    width: 4.1,
    height: 4.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 64.74,
    y: 154.49,
    width: 4.1,
    height: 4.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 59.52,
    y: 159.71,
    width: 4.1,
    height: 7.82
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 64.74,
    y: 159.71,
    width: 4.1,
    height: 7.82
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 59.52,
    y: 168.64,
    width: 4.1,
    height: 7.82
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 64.74,
    y: 168.64,
    width: 4.1,
    height: 7.82
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 83.35,
    y: 151.91,
    width: 23.31,
    height: 14.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,166.64H83.06v-15H107Zm-23.44-.44h23V152.07h-23Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.36,
    y: 153.65,
    width: 3.45,
    height: 3.45
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 89.75,
    y: 153.65,
    width: 3.45,
    height: 3.45
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.36,
    y: 158.04,
    width: 3.45,
    height: 6.58
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 89.75,
    y: 158.04,
    width: 3.45,
    height: 6.58
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 96.82,
    y: 153.65,
    width: 3.45,
    height: 3.45
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.2,
    y: 153.65,
    width: 3.45,
    height: 3.45
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 96.82,
    y: 158.04,
    width: 3.45,
    height: 6.58
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.2,
    y: 158.04,
    width: 3.45,
    height: 6.58
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "76.55 183.53 76.55 181.11 73.88 181.11 73.88 178.42 64.19 178.42 54.49 178.42 54.49 181.11 51.82 181.11 51.82 183.53 49.59 183.53 49.59 186.63 64.19 186.63 78.79 186.63 78.79 183.53 76.55 183.53"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 83.35,
    y: 110.83,
    width: 23.31,
    height: 14.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,125.56H83.06v-15H107Zm-23.44-.44h23V111h-23Z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.36,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 89.75,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.36,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 89.75,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 96.82,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.2,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 96.82,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.2,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 57.42,
    y: 110.83,
    width: 14.63,
    height: 14.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.34,125.57l-15.21,0v-15l15.21,0Zm-14.76-.47,14.32,0V111l-14.32,0Z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.82,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 65.2,
    y: 112.57,
    width: 3.45,
    height: 3.45
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.82,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 65.2,
    y: 116.96,
    width: 3.45,
    height: 6.58
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 116.57,
    y: 3.5,
    width: 77.69,
    height: 183.13
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 137.06,
    y: 3.5,
    width: 51.2,
    height: 144.64
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 162.29,
    y: 3.5,
    width: 0.74,
    height: 139.49
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "195.84 151.92 114.98 151.92 114.98 154.34 185.4 154.34 185.4 186.63 187.82 186.63 187.82 154.34 195.84 154.34 195.84 151.92"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 153.68,
    y: 154.34,
    width: 31.72,
    height: 32.29
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 155.62,
    width: 31.72,
    height: 0.44
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 158.06,
    width: 31.72,
    height: 0.44
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 160.5,
    width: 31.72,
    height: 0.44
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 162.94,
    width: 31.72,
    height: 0.44
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 165.38,
    width: 31.72,
    height: 0.44
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 167.82,
    width: 31.72,
    height: 0.44
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 170.26,
    width: 31.72,
    height: 0.44
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 172.71,
    width: 31.72,
    height: 0.44
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 175.15,
    width: 31.72,
    height: 0.44
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 177.59,
    width: 31.72,
    height: 0.44
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 180.03,
    width: 31.72,
    height: 0.44
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 182.47,
    width: 31.72,
    height: 0.44
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 153.68,
    y: 184.91,
    width: 31.72,
    height: 0.44
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.98,
    y: 154.34,
    width: 29.7,
    height: 32.29
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 132.75,
    y: 160.11,
    width: 20.93,
    height: 26.52
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "131.11 43.17 137.06 62.13 137.06 43.17 131.11 43.17"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "131.11 79.42 137.06 98.38 137.06 79.42 131.11 79.42"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "131.11 115.67 137.06 134.62 137.06 115.67 131.11 115.67"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 188.26,
    y: 41.04,
    width: 5.99,
    height: 94.83
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.11,
    y: 134.62,
    width: 66.12,
    height: 17.29
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.11,
    y: 98.38,
    width: 66.12,
    height: 17.29
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.11,
    y: 62.13,
    width: 66.12,
    height: 17.29
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.11,
    y: 25.88,
    width: 66.12,
    height: 17.29
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.25 24.16 197.23 25.88 194.25 25.88 194.25 24.16"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.25 60.41 197.23 62.13 194.25 62.13 194.25 60.41"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.25 96.66 197.23 98.38 194.25 98.38 194.25 96.66"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.25 132.9 197.23 134.62 194.25 134.62 194.25 132.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33,167.21l-6-2.32a6.76,6.76,0,0,0-1.47-.38l-3.27-.46a3.84,3.84,0,0,1-3.3-3.53l-.3-4.11a4.85,4.85,0,0,1,2.84-4.79L24,150.47a3.13,3.13,0,0,0,.24-5.57l-1.74-1a4.57,4.57,0,0,1-2.3-4.35l.12-1.45A5.19,5.19,0,0,0,19,134.2l-1.6-1.76a2.54,2.54,0,0,1,.12-3.53l.45-.43a1.5,1.5,0,0,0,.45-1.3c-.1-.83-.29-2.19-.47-3.23a.75.75,0,0,1,1.17-.75l6,4.11a2.27,2.27,0,0,0,3.27-.77l.61-1.11a1.73,1.73,0,0,1,1.9-.86l2.18.47a2.19,2.19,0,0,0,1.89-.46l3.92-3.31a2.05,2.05,0,0,1,2.75.5l2.52,3.33a3.44,3.44,0,0,1,.38,3.48l-1.44,3.19a1.09,1.09,0,0,0,1.48,1.42l3.37-1.68a1.22,1.22,0,0,1,1.72.83l.21.9a1.74,1.74,0,0,0,2.05,1.51l2.91-.57A1.42,1.42,0,0,1,56.32,136L55,139.94a4.12,4.12,0,0,0-.11,2.23l.6,2.69h0a3.36,3.36,0,0,1-2.5,3.29l-3.38.9a1,1,0,0,0,0,1.82l.63.32a1.19,1.19,0,0,1,.15,2h0a.84.84,0,0,0,.41,1.51l3.58.38a1.78,1.78,0,0,1,1.38,2.63l-2.33,4.21a3,3,0,0,1-2.83,1.55l-4.15-.27a7.89,7.89,0,0,0-5.72,1.94l-1,.86A6.58,6.58,0,0,1,33,167.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M40.7,134.2h0a1.33,1.33,0,0,1-1.63-1.59l.49-2.08a2,2,0,0,0-2.79-1.88l-2,.92a2.08,2.08,0,0,0-1.67,2.65l.49,1.65A3.65,3.65,0,0,1,32,138.05l-2.3,1.36a2.4,2.4,0,0,0-.2,4l2.79,2.06a1.71,1.71,0,0,1,.26,2.5l-1.09,1.22a2.08,2.08,0,0,0,.12,2.88h0a2.25,2.25,0,0,1-1.15,3.84l-2.42.44a1.51,1.51,0,0,0-.82,2.53l3.5,3.64a2.37,2.37,0,0,1-.42,3.62h0L33,167.21a6.58,6.58,0,0,0,6.7-1.19l2.86-4a3.1,3.1,0,0,0,.22-3.26h0a2.79,2.79,0,0,1,1.86-4l.65-.15a1.66,1.66,0,0,0,.62-3l-.92-.68a1.7,1.7,0,0,1,0-2.75l1-.72a1.35,1.35,0,0,0-.15-2.28h0a1.85,1.85,0,0,1-.4-2.95l1.47-1.44a2.08,2.08,0,0,0-1.83-3.34l-1.71.15a1.68,1.68,0,0,1-1.7-2.32h0A.81.81,0,0,0,40.7,134.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M36.64,127.06,37.19,149l10-7.71.37-5.22s.11,3.94.14,4.82l5.26-4.07L49,140.18h0l4.27,1.08-4.92-.52-5.09,4.38-6,5.18.22,8.93,5.8-.7,1.7-2.53-1.09,2.46,10.51-1.26-5.88,1,2.1,3-2.52-2.94L37.46,160l.66,26.6H35.46l.44-22-7.13-4.34-2.21.65,2-.75-3.42-2.08,2.16,1-.11-1.86.35,2c1.16.56,2.58,1.26,3.94,1.94-.08-1.15-.52-5.69-.52-5.69l.73,5.8c1.81.9,3.47,1.76,4.19,2.19l.36-18.18-4.73-5.11-7.7-4L31,139.62,21.63,129.5l2.66,2.74.33.33-.48-3.07.74,3.34,3.47,3.56.61-4.57-.4,4.79,7.73,7.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasas);
export default __webpack_public_path__ + "static/media/casas.8247e828f4fec7114687d29f4109d3fb.svg";
export { ForwardRef as ReactComponent };